export const NAV_HOME = 'NAV_HOME';
export const NAV_ADMIN = 'NAV_ADMIN';
export const NAV_CATEGORIES = 'NAV_CATEGORIES';
export const NAV_WORKSPACES = 'NAV_WORKSPACES';
export const NAV_FORMS = 'NAV_FORMS';
export const NAV_HIGHLIGHTS = 'NAV_HIGHLIGHTS';
export const NAV_THESAURUS = 'NAV_THESAURUS';
export const NAV_REPORTS = 'NAV_REPORTS';
